// Vendor
import * as React from 'react';

// Vendor Components
import LandscapeIcon from 'material-ui-icons/StayPrimaryLandscape';
import {withStyles} from 'material-ui/styles';
import {StyleRulesCallback, WithStyles} from 'material-ui/styles/withStyles';
import Typography from 'material-ui/Typography';
import {translate, TranslationFunction} from 'react-i18next';
import {compose} from 'recompose';

// Shared Components
import {blue, grey} from 'isee/config/colors';

// Types
interface Props {}

interface TranslatedProps {
  t: TranslationFunction;
}

type EnhancedProps = Props & TranslatedProps & WithStyles;

const styles: StyleRulesCallback = ({breakpoints, spacing}) =>
  ({
    headline: {
      color: blue[500],
      fontSize: 38,
      fontWeight: 500,
      letterSpacing: 1,
      marginBottom: spacing.unit * 2,
      textTransform: 'uppercase'
    },
    landscapeIcon: {
      border: '2px solid',
      borderRadius: 60,
      color: blue[500],
      display: 'inline-block',
      height: 55,
      padding: 6,
      width: 55
    },
    message: {
      color: grey[500],
      fontSize: 18,
      letterSpacing: 0.3,
      lineHeight: 1.5,
      maxWidth: 500
    },
    root: {
      '@media print': {
        display: 'none'
      }
    },
    rotateDevice: {
      [`${breakpoints.down('sm')} and (orientation:portrait)`]: {
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        opacity: 0.9,
        padding: spacing.unit * 5,
        position: 'absolute',
        textAlign: 'center',
        top: 0,
        width: '100%',
        zIndex: 10000
      },
      display: 'none'
    },
    useBiggerScreen: {
      [`${breakpoints.down('sm')} and (orientation:landscape)`]: {
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        opacity: 0.9,
        padding: spacing.unit * 5,
        position: 'absolute',
        textAlign: 'center',
        top: 0,
        width: '100%',
        zIndex: 10000
      },
      display: 'none'
    }
  } as any);

const enhance = compose<EnhancedProps, Props>(translate(), withStyles(styles));

export const RotateDevicePlaceholder: React.SFC<EnhancedProps> = ({
  classes,
  t
}) => (
  <div className={classes.root}>
    <div className={classes.rotateDevice}>
      <LandscapeIcon className={classes.landscapeIcon} />
      <Typography
        variant="headline"
        component="strong"
        className={classes.headline}
      >
        {t('rotate_device.headline')}
      </Typography>

      <Typography variant="display3" className={classes.message}>
        {t('rotate_device.message')}
      </Typography>
    </div>

    <div className={classes.useBiggerScreen}>
      <LandscapeIcon className={classes.landscapeIcon} />
      <Typography
        variant="headline"
        component="strong"
        className={classes.headline}
      >
        {t('use_bigger_screen.headline')}
      </Typography>

      <Typography variant="display3" className={classes.message}>
        {t('use_bigger_screen.message')}
      </Typography>
    </div>
  </div>
);

RotateDevicePlaceholder.displayName = 'RotateDevicePlaceholder';

export default enhance(RotateDevicePlaceholder);



// WEBPACK FOOTER //
// ./src/ui/components/rotate-device-placeholder/rotate-device-placeholder.tsx